/* ================================
  Wishlist (AJAX, localStorage based)
================================ */
(function () {
  'use strict';

  if (window.__wishlistInitialized) return;
  window.__wishlistInitialized = true;

  var STORAGE_KEY = 'shopify-wishlist-v1';
  var MAX_ITEMS = 100;
  var pendingRemove = null;

  /* ---------- Storage helpers ---------- */
  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (e) {
      console.warn('Wishlist: unable to save.');
    }
  }

  function isInWishlist(productId) {
    return getList().some(function (item) {
      return String(item.id) === String(productId);
    });
  }

  function addToWishlist(item) {
    if (!item || !item.id) return;
    var list = getList().filter(function (i) {
      return String(i.id) !== String(item.id);
    });
    list.unshift(item);
    saveList(list);
    updateAllIcons();
    updateCounts();
    renderWishlistTab();
  }

  function removeFromWishlist(productId) {
    var list = getList().filter(function (i) {
      return String(i.id) !== String(productId);
    });
    saveList(list);
    updateAllIcons();
    updateCounts();
    renderWishlistTab();
  }

  function toggleWishlist(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) return;

    if (isInWishlist(id)) {
      removeFromWishlist(id);
    } else {
      addToWishlist({
        id: id,
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        image: btn.getAttribute('data-product-image'),
        url: btn.getAttribute('data-product-url'),
        price: btn.getAttribute('data-product-price')
      });
    }
  }

  /* ---------- UI sync ---------- */
  function updateAllIcons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = isInWishlist(btn.getAttribute('data-product-id'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateCounts() {
    var count = getList().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function switchToTab(tab) {
    document.querySelectorAll('.cd-tab-btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-tab') === tab);
    });

    var itemsPanel = document.getElementById('CartDrawerItemsPanel');
    var recPanel = document.getElementById('cart-recommendations');
    var footerPanel = document.getElementById('CartDrawer-Footer');
    var wishlistPanel = document.getElementById('CartDrawerWishlistPanel');
    var emptyState = document.getElementById('CartDrawerEmptyState');
    var bagHeader = document.getElementById('CartDrawer-BagHeader');

    var showWishlist = tab === 'wishlist';

    if (itemsPanel) itemsPanel.hidden = showWishlist;
    if (recPanel) recPanel.style.display = showWishlist ? 'none' : '';
    if (footerPanel) footerPanel.hidden = showWishlist;
    if (bagHeader) bagHeader.hidden = showWishlist;
    if (emptyState) emptyState.hidden = showWishlist;
    if (wishlistPanel) wishlistPanel.hidden = !showWishlist;
  }

  function openDrawerWishlistTab() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    switchToTab('wishlist');
  }
  window.openDrawerWishlistTab = openDrawerWishlistTab;
  window.switchToTab = switchToTab;

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.wishlistMoneyFormat || '₹{{amount}}');
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  /* ---------- Render wishlist tab ---------- */
  function buildWishlistCard(item, apiProduct) {
    var price = apiProduct ? apiProduct.price : Number(item.price || 0);
    var comparePrice = apiProduct ? apiProduct.compare_at_price : 0;
    var image = (apiProduct && apiProduct.featured_image) || item.image || '';
    var title = (apiProduct && apiProduct.title) || item.title || '';
    var url = item.url || (item.handle ? '/products/' + item.handle : '#');
    var available = apiProduct ? apiProduct.available : true;
    var variant =
      apiProduct && apiProduct.variants && apiProduct.variants.length
        ? apiProduct.variants.find(function (v) { return v.available; }) || apiProduct.variants[0]
        : null;

    var priceHTML =
      comparePrice > price
        ? '<span class="wl-price">' + formatMoney(price) + '</span> <s class="wl-compare">' + formatMoney(comparePrice) + '</s>'
        : '<span class="wl-price">' + formatMoney(price) + '</span>';

    return (
      '<div class="wl-card" data-wishlist-item="' + item.id + '">' +
        '<a href="' + url + '" class="wl-card__img-link" tabindex="-1">' +
          (image ? '<img src="' + image + '" alt="' + String(title).replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="wl-card__body">' +
          '<a href="' + url + '" class="wl-card__title">' + title + '</a>' +
          '<div class="wl-card__price">' + priceHTML + '</div>' +
          '<div class="wl-card__actions">' +
            '<button type="button" class="wl-card__add-btn" data-wl-add-to-cart' +
              (variant ? ' data-variant-id="' + variant.id + '"' : '') +
              (!available ? ' disabled' : '') + '>' +
              (available ? 'ADD TO BAG' : 'SOLD OUT') +
            '</button>' +
            '<button type="button" class="wl-card__remove-btn" data-wl-remove="' + item.id + '" aria-label="Remove from wishlist">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
                '<path d="M3 6h18"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/>' +
                '<path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderWishlistTab() {
    var container = document.getElementById('CartDrawerWishlistPanel');
    if (!container) return;
    var list = getList();

    if (!list.length) {
      container.innerHTML = '<div class="wl-empty">Your wishlist is empty.</div>';
      return;
    }

    container.innerHTML = '<div class="wl-loading">Loading...</div>';

    Promise.all(
      list.map(function (item) {
        if (!item.handle) return Promise.resolve(null);
        return fetch('/products/' + encodeURIComponent(item.handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (results) {
      var html = list.map(function (item, i) { return buildWishlistCard(item, results[i]); }).join('');
      container.innerHTML = html || '<div class="wl-empty">Your wishlist is empty.</div>';
    });
  }
  window.renderWishlistTab = renderWishlistTab;

  /* ---------- Keep outer is-empty classes in sync after AJAX refresh ---------- */
  function syncEmptyStateClasses() {
    var outerDrawer = document.querySelector('cart-drawer');
    var itemsPanel = document.getElementById('CartDrawerItemsPanel');
    var hasItems = !!(itemsPanel && itemsPanel.querySelector('.cd-cart-item'));

    if (outerDrawer) outerDrawer.classList.toggle('is-empty', !hasItems);
    if (itemsPanel) itemsPanel.classList.toggle('is-empty', !hasItems);
  }
  window.syncCartDrawerEmptyState = syncEmptyStateClasses;

  /* ---------- Patch refreshCartDrawer so wishlist UI always resyncs after cart refresh ---------- */
  function patchRefreshCartDrawer() {
    if (typeof window.refreshCartDrawer !== 'function' || window.refreshCartDrawer.__wishlistPatched) {
      return;
    }

    var originalRefresh = window.refreshCartDrawer;

    var patched = function () {
      return originalRefresh.apply(this, arguments).then(function (result) {
        syncEmptyStateClasses();
        updateAllIcons();
        updateCounts();
        renderWishlistTab();
        return result;
      });
    };

    patched.__wishlistPatched = true;
    window.refreshCartDrawer = patched;
  }

  patchRefreshCartDrawer();
  document.addEventListener('DOMContentLoaded', patchRefreshCartDrawer);

  var __patchPollTimer = setInterval(function () {
    patchRefreshCartDrawer();
    if (window.refreshCartDrawer && window.refreshCartDrawer.__wishlistPatched) {
      clearInterval(__patchPollTimer);
    }
  }, 100);
  setTimeout(function () { clearInterval(__patchPollTimer); }, 10000);

  function waitForRefreshCartDrawer(timeout) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function check() {
        if (typeof window.refreshCartDrawer === 'function') {
          return resolve(window.refreshCartDrawer);
        }
        if (Date.now() - start > (timeout || 3000)) {
          return resolve(null);
        }
        setTimeout(check, 50);
      })();
    });
  }

  /* ---------- Remove -> Move to wishlist confirm popup ---------- */
  function closeConfirmModal() {
    var modal = document.getElementById('WishlistConfirmModal');
    if (modal && modal.parentNode) {
      modal.parentNode.removeChild(modal);
    }
    pendingRemove = null;
  }
  window.closeWishlistConfirmModal = closeConfirmModal;

  function performCartRemove(line) {
    patchRefreshCartDrawer();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    }).then(function () {
      window.refreshCartDrawer && window.refreshCartDrawer();
    });
  }

  function buildConfirmModal(payload) {
    // Always start clean so we never have two stacked modals or stale listeners.
    closeConfirmModal();

    pendingRemove = payload;

    var host = document.getElementById('CartDrawer') || document.body;
    var modal = document.createElement('div');
    modal.id = 'WishlistConfirmModal';
    modal.className = 'wl-confirm-overlay';
    modal.innerHTML =
      '<div class="wl-confirm-modal" role="dialog" aria-modal="true">' +
        '<p class="wl-confirm-title">Remove this item from your bag?</p>' +
        '<p class="wl-confirm-sub">Move it to your Wishlist so it isn\'t lost, or remove it completely.</p>' +
        '<div class="wl-confirm-actions">' +
          '<button type="button" class="wl-confirm-btn wl-confirm-btn--move" id="WishlistConfirmMove">Move to Wishlist</button>' +
          '<button type="button" class="wl-confirm-btn wl-confirm-btn--remove" id="WishlistConfirmRemove">Remove</button>' +
          '<button type="button" class="wl-confirm-btn wl-confirm-btn--cancel" id="WishlistConfirmCancel">Cancel</button>' +
        '</div>' +
      '</div>';

    host.appendChild(modal);

    // Click on the dimmed backdrop itself (not the inner box) -> cancel
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeConfirmModal();
    });

    // Attach direct, non-delegated listeners to each action button.
    var moveBtn = modal.querySelector('#WishlistConfirmMove');
    var removeBtn = modal.querySelector('#WishlistConfirmRemove');
    var cancelBtn = modal.querySelector('#WishlistConfirmCancel');

    moveBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var current = pendingRemove;
      if (current) {
        addToWishlist(current.item);
        performCartRemove(current.line);
      }
      closeConfirmModal();
    });

    removeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var current = pendingRemove;
      if (current) {
        performCartRemove(current.line);
        if (current.item && current.item.id && isInWishlist(current.item.id)) {
          removeFromWishlist(current.item.id);
        }
      }
      closeConfirmModal();
    });

    cancelBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeConfirmModal();
    });
  }

  function askRemoveConfirmation(payload) {
    buildConfirmModal(payload);
  }

  /* ---------- Global click delegation (heart toggle, tabs, wishlist card actions) ---------- */
  document.addEventListener('click', function (e) {
    // Wishlist heart toggle (card / cart item / main product)
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      toggleWishlist(toggleBtn);
      return;
    }

    // Tabs
    var tabBtn = e.target.closest('.cd-tab-btn');
    if (tabBtn) {
      switchToTab(tabBtn.getAttribute('data-tab'));
      return;
    }

    // Add to cart from wishlist card
    var addBtn = e.target.closest('[data-wl-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled || addBtn.dataset.wlBusy === 'true') return;
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      addBtn.disabled = true;
      addBtn.dataset.wlBusy = 'true';
      addBtn.textContent = 'Adding...';

      patchRefreshCartDrawer();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error((err && err.description) || 'Could not add to cart');
            });
          }
          return res.json();
        })
        .then(function () {
          var card = addBtn.closest('[data-wishlist-item]');
          var itemId = card ? card.getAttribute('data-wishlist-item') : null;
          if (itemId) removeFromWishlist(itemId);

          patchRefreshCartDrawer();
          return waitForRefreshCartDrawer().then(function (fn) {
            return fn ? fn() : null;
          });
        })
        .then(function () {
          switchToTab('bag');
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
            drawer.open();
          }
        })
        .catch(function (err) {
          console.error('Wishlist add-to-cart error:', err);
          if (document.body.contains(addBtn)) {
            addBtn.disabled = false;
            addBtn.dataset.wlBusy = 'false';
            addBtn.textContent = 'Try Again';
            setTimeout(function () {
              if (document.body.contains(addBtn)) addBtn.textContent = 'ADD TO BAG';
            }, 1500);
          }
        });
      return;
    }

    // Remove from wishlist tab
    var wlRemoveBtn = e.target.closest('[data-wl-remove]');
    if (wlRemoveBtn) {
      e.preventDefault();
      removeFromWishlist(wlRemoveBtn.getAttribute('data-wl-remove'));
      return;
    }
  });

  // Intercept cart-drawer's remove button BEFORE the theme's default handler runs
  document.addEventListener(
    'click',
    function (e) {
      var removeCartBtn = e.target.closest('.cd-cart-item__remove');
      if (!removeCartBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = removeCartBtn.closest('.cd-cart-item');
      var itemIndex = wrapper && wrapper.id ? wrapper.id.replace('CartDrawer-Item-', '') : null;

      askRemoveConfirmation({
        line: Number(itemIndex),
        item: {
          id: wrapper ? wrapper.getAttribute('data-product-id') : null,
          handle: wrapper ? wrapper.getAttribute('data-product-handle') : null,
          title: wrapper ? wrapper.getAttribute('data-product-title') : null,
          image: wrapper ? wrapper.getAttribute('data-product-image') : null,
          url: wrapper ? wrapper.getAttribute('data-product-url') : null,
          price: wrapper ? wrapper.getAttribute('data-product-price') : null
        }
      });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    syncEmptyStateClasses();
    updateAllIcons();
    updateCounts();
    renderWishlistTab();
  });

  document.addEventListener('shopify:section:load', function () {
    syncEmptyStateClasses();
    updateAllIcons();
    updateCounts();
    renderWishlistTab();
  });

  window.Wishlist = {
    add: addToWishlist,
    remove: removeFromWishlist,
    isInWishlist: isInWishlist,
    toggle: toggleWishlist,
    render: renderWishlistTab,
    updateIcons: updateAllIcons
  };
})();